export default __webpack_public_path__ + "static/media/77.526e5e9a.jpg";